import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface IManagmentSlice {
  isSendingWelcomeEmails: boolean;
  selectAll: boolean;
  usersToSendWelcomeEmail: string[];
}

const initialState: IManagmentSlice = {
  isSendingWelcomeEmails: false,
  selectAll: false,
  usersToSendWelcomeEmail: [],
};

export const managementSlice = createSlice({
  name: "managementSlice",
  initialState,
  reducers: {
    setIsSendingWelcomeEmail: (state, action: PayloadAction<boolean>) => {
      state.isSendingWelcomeEmails = action.payload;
    },
    toggleUserToSendWelcomeEmail: (
      state,
      action: PayloadAction<{ userid: string; staySelected: boolean }>,
    ) => {
      const checkIfIncludes = state.usersToSendWelcomeEmail.includes(
        action.payload.userid,
      );
      if (checkIfIncludes && action.payload.staySelected) return;

      if (checkIfIncludes) {
        state.usersToSendWelcomeEmail = state.usersToSendWelcomeEmail.filter(
          userId => userId !== action.payload.userid,
        );
      } else {
        state.usersToSendWelcomeEmail.push(action.payload.userid);
      }
    },
    clearUsersToSendWelcomeEmail: state => {
      state.usersToSendWelcomeEmail = [];
    },
    setSelectAll: (state, action: PayloadAction<boolean>) => {
      state.selectAll = action.payload;
    },
  },
});

export const {
  setIsSendingWelcomeEmail,
  toggleUserToSendWelcomeEmail,
  clearUsersToSendWelcomeEmail,
  setSelectAll,
} = managementSlice.actions;

export default managementSlice.reducer;
